export default {
  'components.DialogSelecFolder.348250-0': 'Enter keywords to search Class',
  'components.DialogSelecFolder.348250-1': 'Search',
  'components.DialogSelecFolder.348250-2': 'New Class',
  'components.DialogSelecFolder.348250-3': 'Select Class',
  'components.DialogSelecFolder.348250-4': 'Interface Error',
  'components.DialogSelecFolder.348250-5': 'Enter Class Name (3 digits + name/letters/digits/-/_).',
  'components.DialogSelecFolder.348250-5-1': 'Enter Class Name',
  'components.DialogSelecFolder.348250-6': 'New {0} Class',
  'components.DialogSelecFolder.348250-7': 'OK',
  'components.DialogSelecFolder.348250-8': 'Cancel',
  'components.DialogSelecFolder.348250-9': 'Naming does not conform to the specifications.',
  'components.DialogSelecFolder.348250-10': 'Input Class names',
  'components.DialogSelecFolder.348250-11': 'Operation fail',
  'components.DialogSelecFolder.348250-13': 'New Class {1} under【{0}】Successful.',
  'components.DialogSelecFolder.348250-14': 'Rename',
  'components.IppInfo.170660-0': 'Location',
  'components.IppInfo.170660-1': 'Exposure time(μs)',
  'components.IppInfo.170660-2': 'Frame Rate(fps)',
  'components.IppInfo.170660-3': 'Last online',
  'components.IppInfo.170660-4': 'Total online (h) ',
  'components.IppInfo.170660-5': '',
  'components.IppInfo.170660-6': 'Wiper',
  'components.IppInfo.170660-7': 'Clean interval(min)',
  'components.IppInfo.170660-8': 'Last Clean',
  'components.IppInfo.170660-9': 'Strokes/Clean',
  'components.IppInfo.170660-10': 'Total Clean',
  'components.IppInfo.170660-11': 'Sampling Volume',
  'components.IppInfo.170660-12': 'Last 5min Volume (mL)',
  'components.IppInfo.170660-13': 'Total Volume (L)',
  'components.IppInfo.170660-14': 'Data Details',
  'components.IppInfo.170660-15': 'Today ROI# ',
  'components.IppInfo.170660-16': 'Total ROI#',
  'components.IppInfo.170660-17': 'Last update',
  'components.IppInfo.170660-18': 'Longitude{0}, Latitude{1}',
  'components.IppInfo.170660-19': 'Location:',
  'user.index.685648-0': 'Account',
  'user.index.685648-1': 'Email',
  'user.index.685648-2': 'Phone',
  'user.index.685648-3': 'Search',
  'user.index.685648-4': 'Add',
  'user.index.685648-5': 'Team Management',
  'user.index.685648-6': 'User',
  'user.index.685648-7': 'Phone',
  'user.index.685648-8': 'Character',
  'user.index.685648-9': 'Super Admin',
  'user.index.685648-10': 'Team Admin',
  'user.index.685648-11': 'User',
  'user.index.685648-12': 'Edit',
  'user.index.685648-13': 'Remove',
  'user.index.685648-14': 'Every team has 1 administrator and 3 users',
  'user.index.685648-15': 'Remove?',
  'user.index.685648-16': 'Warning',
  'user.index.685648-17': 'OK',
  'user.index.685648-18': 'Cancel',
  'user.index.685648-19': 'Delete fail',
  'user.index.685648-20': 'Delete successful',
  'user.edit.990448-0': 'Return',
  'user.edit.990448-1': 'Save',
  'user.edit.990448-2': 'ID',
  'user.edit.990448-3': 'User',
  'user.edit.990448-4': 'Password',
  'user.edit.990448-5': 'Phone#',
  'user.edit.990448-6': 'Email',
  'user.edit.990448-7': 'Team',
  'user.edit.990448-8': 'Select Team',
  'user.edit.990448-9': 'New Team',
  'user.edit.990448-10': 'Super Admin #',
  'user.edit.990448-11': 'Team Admin #',
  'user.edit.990448-12': 'User #',
  'user.edit.990448-13': 'Character',
  'user.edit.990448-14': 'Select Character',
  'user.edit.990448-15': 'Create Team',
  'user.edit.990448-16': 'Name',
  'user.edit.990448-17': 'Cancel',
  'user.edit.990448-18': 'OK',
  'user.edit.990448-19': 'Input ID',
  'user.edit.990448-20': 'Input User',
  'user.edit.990448-21': 'Input Password',
  'user.edit.990448-22': '6 characters minimum',
  'user.edit.990448-23': 'input phone#',
  'user.edit.990448-24': 'input email',
  'user.edit.990448-25': 'input Team name',
  'user.edit.990448-26': 'Operation successful',
  'user.edit.990448-27': 'Team creation successful',
  'system.index.241182-0': 'Team Management',
  'system.index.241182-1': 'Multi-language',
  'system.index.241182-2': 'Save',
  'system.index.241182-3': 'Update',
  'system.index.241182-4': 'Upload',
  'system.index.241182-5': 'Select IPP',
  'system.index.241182-6': 'Interface Error',
  'system.index.241182-7': 'Save successful',
  'components.DialogSelectCategory.222105-0': 'Input key words to search for classes',
  'components.DialogSelectCategory.222105-1': 'Search',
  'components.DialogSelectCategory.222105-2': 'New Class',
  'components.DialogSelectCategory.222105-3': 'Select Class',
  'components.DialogSelectCategory.222105-4': 'Move in',
  'components.DialogSelectCategory.222105-5': 'Copy to',
  'components.DialogSelectCategory.222105-6': 'Interface Error',
  'components.DialogSelectCategory.222105-7': 'input Class name',
  'components.DialogSelectCategory.222105-8': 'New {0} Class',
  'components.DialogSelectCategory.222105-9': 'OK',
  'components.DialogSelectCategory.222105-10': 'Cancel',
  'components.DialogSelectCategory.222105-11': 'input Class name',
  'components.DialogSelectCategory.222105-12': 'Operation fail',
  'components.DialogSelectCategory.222105-14': 'New Class {1} under 【{0}】successful ',
  'components.DialogSelectCategory.222105-15':
    'Are you sure to move <span style="color: red;font-weight: 700;">{0}</span> ROIs \n          <span style="color: red;font-weight: 700;">{1}</span> to \n          <span style="color: red;font-weight: 700;"> {2}</span>?',
  'components.DialogSelectCategory.222105-16': 'Operation Instruction',
  'components.DialogSelectCategory.222105-17': 'Operation successful',
  'ipp.index.402666-0': 'Online Status',
  'ipp.index.402666-1': 'Location',
  'ipp.index.402666-2': 'Search',
  'ipp.index.402666-3': 'Add IPP',
  'ipp.index.402666-4': 'All IPPs',
  'ipp.index.402666-5': 'Site',
  'ipp.index.402666-6': 'Site ID',
  'ipp.index.402666-7': 'IPP SN',
  'ipp.index.402666-8': 'Wiper Status',
  'ipp.index.402666-9': 'Configuration',
  'ipp.index.402666-10': 'View',
  'ipp.index.402666-11': 'Delete',
  'ipp.index.402666-12': 'Interface Error',
  'ipp.index.402666-13': 'Are you sure this operation?',
  'ipp.index.402666-14': 'Warning',
  'ipp.index.402666-15': 'Confirm',
  'ipp.index.402666-16': 'Cancel',
  'ipp.index.402666-17': 'Group',
  'components.DialogSelectUserCategory.619244-0': 'Input key words tp search Class',
  'components.DialogSelectUserCategory.619244-1': 'Search',
  'components.DialogSelectUserCategory.619244-2': 'New Class',
  'components.DialogSelectUserCategory.619244-3': 'Add',
  'components.DialogSelectUserCategory.619244-4': 'example ROIs',
  'components.DialogSelectUserCategory.619244-5': 'Invalid image',
  'components.DialogSelectUserCategory.619244-6': 'Similarity',
  'components.DialogSelectUserCategory.619244-7': 'UI ROIs',
  'components.DialogSelectUserCategory.619244-8': 'Total number',
  'components.DialogSelectUserCategory.619244-9': 'comparison',
  'components.DialogSelectUserCategory.619244-10': 'Select reference ROI',
  'components.DialogSelectUserCategory.619244-11': 'Select Class',
  'components.DialogSelectUserCategory.619244-12': 'Interface Error',
  'components.DialogSelectUserCategory.619244-13': 'enter Class name (three digits + name/letters/digits/-/_).',
  'components.DialogSelectUserCategory.619244-14': 'New {0} Class',
  'components.DialogSelectUserCategory.619244-15': 'OK',
  'components.DialogSelectUserCategory.619244-16': 'Cancel',
  'components.DialogSelectUserCategory.619244-17': 'Name format not supported',
  'components.DialogSelectUserCategory.619244-18': 'input Class name',
  'components.DialogSelectUserCategory.619244-19': 'Operation fail',
  'components.DialogSelectUserCategory.619244-21': 'New Class {1} under 【{0}】successful',
  'components.DialogSelectUserCategory.619244-22':
    '<span style="color: red;font-weight: 700;">{0}</span>class not existed under HI，are you sure to new Class?',
  'components.DialogSelectUserCategory.619244-23': 'Operation Instruction',
  'components.DialogSelectUserCategory.619244-24':
    'Are you sure to move <span style="color: red;font-weight: 700;">{0}</span> ROIs\n          <span style="color: red;font-weight: 700;">{1}</span> to\n          <span style="color: red;font-weight: 700;"> {2}</span>?',
  'ipp.edit.032646-0': 'Return',
  'ipp.edit.032646-1': 'Save',
  'ipp.edit.032646-2': 'Network config.',
  'ipp.edit.032646-3': 'IPP Info',
  'ipp.edit.032646-4': 'Site ID',
  'ipp.edit.032646-5': 'e.g. 21005, required',
  'ipp.edit.032646-6': 'Site',
  'ipp.edit.032646-7': 'Longitude(°)',
  'ipp.edit.032646-8': 'Latitude(°)',
  'ipp.edit.032646-9': 'Team',
  'ipp.edit.032646-10': 'IPP SN',
  'ipp.edit.032646-11': 'Online Status',
  'ipp.edit.032646-12': 'Total Online(Hour)',
  'ipp.edit.032646-13': '',
  'ipp.edit.032646-14': 'Latest online time(Time)',
  'ipp.edit.032646-15': '',
  'ipp.edit.032646-16': 'Internal Temp(℃)',
  'ipp.edit.032646-17': 'Internal Hum(%)',
  'ipp.edit.032646-18': 'Sampling volume in 5min(mL)',
  'ipp.edit.032646-19': 'Total sampling volume(L)',
  'ipp.edit.032646-20': 'RAM(Mb)',
  'ipp.edit.032646-21': 'Storage(Gb)',
  'ipp.edit.032646-22': 'CPU Temp(℃)',
  'ipp.edit.032646-23': 'GPU Temp(℃)',
  'ipp.edit.032646-24': 'Camera',
  'ipp.edit.032646-25': 'Exposure time(μs)',
  'ipp.edit.032646-26': 'Defaul: 80, 80-120 recommended',
  'ipp.edit.032646-27': 'FPS',
  'ipp.edit.032646-28': 'Default:3.0, upper limit 29, 1-7 recommended',
  'ipp.edit.032646-29': 'Gain',
  'ipp.edit.032646-30': 'Preprocessing setting',
  'ipp.edit.032646-31': 'Focusing threshold',
  'ipp.edit.032646-32': 'Default: 700 or 800',
  'ipp.edit.032646-33': 'Size filter threshold',
  'ipp.edit.032646-34': 'Default: 2000-3000',
  'ipp.edit.032646-35': 'Binarization threshold',
  'ipp.edit.032646-36': 'Default: 3 or 5',
  'ipp.edit.032646-37': 'BG-FFI#(pc)',
  'ipp.edit.032646-38': 'pc',
  'ipp.edit.032646-39': 'Default: 50',
  'ipp.edit.032646-40': 'BG-FFI Acuisition Frequency(Second)',
  'ipp.edit.032646-41': 'Second',
  'ipp.edit.032646-42': 'Default: 720',
  'ipp.edit.032646-43': 'Wiper',
  'ipp.edit.032646-44': 'Wiper Status',
  'ipp.edit.032646-45': 'Clean interval(min)',
  'ipp.edit.032646-46': 'min',
  'ipp.edit.032646-47': '30 or 60min recommended',
  'ipp.edit.032646-48': 'Stroke# for every clean',
  'ipp.edit.032646-49': '2 recommended',
  'ipp.edit.032646-50': 'Total clean#',
  'ipp.edit.032646-51': 'Please select a Team!',
  'ipp.edit.032646-52': 'Are you sure?',
  'ipp.edit.032646-53': 'Indication',
  'ipp.edit.032646-54': 'OK',
  'ipp.edit.032646-55': 'Cancel',
  'ipp.edit.032646-56': 'Save successful',
  'ipp.edit.032646-57': 'UVC LED',
  'ipp.edit.032646-58': 'UVC Frequency (port)',
  'ipp.edit.032646-59': 'UVC Duty Cycle (port)',
  'ipp.edit.032646-60': 'UVC Frequency (illuminator)',
  'ipp.edit.032646-61': 'UVC Duty Cycle (illuminator)',
  'ipp.edit.032646-62': 'UVC Module Voltage',
  'ipp.edit.032646-63': 'UVC Module Current',
  'ipp.edit.032646-64': 'Low-power PCB',
  'ipp.edit.032646-65': 'Low-power PCB Current',
  'ipp.edit.032646-66': 'Low-power PCB Voltage',
  'ipp.edit.032646-67': 'Low-power PCB Temp',
  'ipp.edit.032646-68': 'Carrier PCB Current',
  'ipp.edit.032646-69': 'Carrier PCB Voltage',
  'components.DialogTip.249959-0': 'Operation instruction',
  'components.DialogTip.249959-1': 'Are you sure to move {0} to the Recycle Bin?',
  'components.DialogTip.249959-2': 'Are you sure to move {0} to the HI ROIs?',
  'components.DialogTip.249959-3': 'Are you sure to move {0} to the Temp. Class {1}?',
  'components.DialogTip.249959-4': 'Are you sure to copy {0} to {1}?',
  'components.DialogTip.249959-5': 'Attension:',
  'components.DialogTip.249959-6': 'Cancel',
  'components.DialogTip.249959-7': 'Confirm',
  'components.DialogTip.249959-8': 'Interface not supported',
  'ipp-image-detail.index.728695-0': 'ROI Measurement',
  'ipp-image-detail.index.728695-1': 'Class',
  'ipp-image-detail.index.728695-2': 'Class:',
  'ipp-image-detail.index.728695-3': 'Remarks',
  'ipp-image-detail.index.728695-4': 'Invalid image',
  'ipp-image-detail.index.728695-5': 'Download ROI',
  'ipp-image-detail.index.728695-6': 'Click to measure object size',
  'ipp-image-detail.index.728695-7': 'Measure',
  'ipp-image-detail.index.728695-8': 'Click to enhance',
  'ipp-image-detail.index.728695-9': 'Enhance',
  'ipp-image-detail.index.728695-10': 'Click to reset',
  'ipp-image-detail.index.728695-11': 'Reset',
  'ipp-image-detail.index.728695-12': 'Acq. time',
  'ipp-image-detail.index.728695-13': 'Click the ROI to close',
  'ipp-image-detail.index.728695-14': 'Last',
  'ipp-image-detail.index.728695-15': 'Next',
  'ipp-image-detail.index.728695-16': 'Similarity Refs.',
  'ipp-image-detail.index.728695-17': 'ROI info. obtain fail',
  'ipp-image-detail.index.728695-18': 'Invalid image',
  'ipp-image-detail.index.728695-19': 'Interface Error',
  'ipp-image-detail.index.728695-20': 'Select Class for HI',
  'ipp-image-detail.index.728695-21': 'Operation successful',
  'ipp-image-detail.index.728695-22': 'Operation not supported',
  'ipp-image-detail.index.728695-23': 'Select Class from Favorite Gallery',
  'ipp-image-detail.index.728695-24': 'Move to Recycle Bin',
  'ipp-image-detail.index.728695-25': 'Remove',
  'ipp-image-detail.index.728695-26': 'Move out of Gallery',
  'ipp-image-detail.index.728695-27': 'Move out of Favorite Gallery',
  'ipp-image-detail.index.728695-28': 'Delete',
  'ipp-image-detail.index.728695-29': 'Please confirm {0}？',
  'ipp-image-detail.index.728695-30': 'Operation Instruction',
  'ipp-image-detail.index.728695-31': 'Operation Fail',
  'ipp-image-detail.index.728695-32': 'Success',
  'ipp-image-detail.index.728695-33': 'Click to flip',
  'ipp-image-detail.index.728695-34': 'Click cancel flip',
  'ipp_image.tab1.957792-10-2': 'Click to hide the scale bar',
  'ipp_image.tab1.957792-10-3': 'Click to show the scale bar',
  'components.RoiInfo.081322-0': 'Data Details',
  'components.RoiInfo.081322-1': 'Last update',
  'components.RoiInfo.081322-2': 'Current ROI',
  'components.RoiInfo.081322-3': 'Today',
  'components.RoiInfo.081322-4': 'pc',
  'components.RoiInfo.081322-5': 'Total',
  'components.RoiInfo.081322-6': '10^4 pc',
  'components.RoiInfo.081322-7': 'Invalid image',
  'components.ViewRoiWall.247370-0': 'sec.',
  'components.ViewRoiWall.247370-1': 'View Video',
  'components.ViewRoiWall.247370-2': 'Interface Error',
  'components.ViewRoiWall.247370-3': 'Latest Data',
  'group.index.406888-0': 'Team Name',
  'group.index.406888-1': 'Search',
  'group.index.406888-2': 'Add Team',
  'group.index.406888-3': 'Team ID',
  'group.index.406888-4': 'Admin ID',
  'group.index.406888-5': 'Admin Name',
  'group.index.406888-6': 'Rename',
  'group.index.406888-7': 'Remove',
  'group.index.406888-8': 'New',
  'group.index.406888-9': 'Update',
  'group.index.406888-10': 'Cancel',
  'group.index.406888-11': 'Confirm',
  'group.index.406888-12': 'Are you sure this operation?',
  'group.index.406888-13': 'Warning',
  'group.index.406888-14': 'Submission successful!',
  'group.index.406888-15': 'Please check the required items!',
  'components.images.410755-0': 'Invalid image',
  'components.images.410755-1': 'File Size',
  'components.images.410755-2': 'No data sampled',
  'components.images.410755-3': 'Latest data',
  'components.EChartsBar.526258-0': 'IPP',
  'components.EChartsBar.526258-1': 'Number',
  'components.EChartsBar.526258-2': 'Abundance',
  'components.EChartsBar.526258-3': 'Volume',
  'components.EChartsBar.526258-4': 'Size',
  'components.EChartsBar.526258-5': 'Temp.',
  'components.EChartsBar.526258-6': 'Hum.',
  'components.EChartsBar.526258-7': 'Interal Temp.',
  'components.EChartsBar.526258-8': 'Internal Hum.',
  'views.login.585449-0': 'Account',
  'views.login.585449-1': 'Password',
  'views.login.585449-2': 'Login',
  'views.login.585449-3': 'Configure Request Domain Names',
  'views.login.585449-4': 'The login password should be at least 6 characters.',
  'views.login.585449-5': 'Configuration successful',
  'EChartsBar.DialogSelectDate.617290-0': 'Select Date/Time',
  'EChartsBar.DialogSelectDate.617290-1': 'Click the Start and End Dates to Define a Time Range.',
  'EChartsBar.DialogSelectDate.617290-2': '-',
  'EChartsBar.DialogSelectDate.617290-3': 'Start Date Time',
  'EChartsBar.DialogSelectDate.617290-4': 'End Date Time',
  'EChartsBar.DialogSelectDate.617290-5': 'Last 24 Hour',
  'EChartsBar.DialogSelectDate.617290-6': '3 Days',
  'EChartsBar.DialogSelectDate.617290-7': '7 Days',
  'EChartsBar.DialogSelectDate.617290-8': '15 Days',
  'EChartsBar.DialogSelectDate.617290-9': '1 Month',
  'EChartsBar.DialogSelectDate.617290-10': '3 Months',
  'EChartsBar.DialogSelectDate.617290-11': '6 Months',
  'EChartsBar.DialogSelectDate.617290-12': '1 Year',
  'views.404.671921-0': 'Oops, the page you visit does not exist',
  'views.404.671921-1': 'Return to Homepage',
  'views.404.671921-2': 'Return to last page',
  'views.403.724508-0': 'OOps, You do not have the right to visit this page',
  'views.403.724508-1': 'Return to Homepage',
  'views.403.724508-2': 'Return to last page',
  'EChartsBar.index.759330-0': 'Data Histogram',
  'EChartsBar.index.759330-1': 'Period Define',
  'EChartsBar.index.759330-2': 'Data Download',
  'EChartsBar.index.759330-3': 'Selected',
  'EChartsBar.index.759330-4': 'Unselected',
  'EChartsBar.index.759330-5': 'Interface error',
  'EChartsBar.index.759330-6': 'Querying all the data is very time-consuming. Are you sure to proceed?',
  'EChartsBar.index.759330-7': 'Warning',
  'EChartsBar.index.759330-8': 'Number',
  'EChartsBar.index.759330-9': 'Last 24 Hour',
  'EChartsPie.index.886326-0': 'ROI Classification',
  'EChartsPie.index.886326-1': 'All Classes',
  'EChartsPie.index.886326-2': 'Only Top 6 Classes Displayed',
  'EChartsPie.index.886326-3': 'Interface error',
  'EChartsPie.index.886326-4': 'Number',
  'EChartsPie.index.886326-5': 'Classification',
  'layout.LayoutHeader.955383-0': 'Exit',
  'RoiBrowser.IppFolder.011501-0': 'x 10k',
  'RoiBrowser.IppFolder.011501-1': 'System Class, Delete Not Supported',
  'RoiBrowser.IppFolder.011501-2': 'Delete',
  'RoiBrowser.IppImages.077288-0': 'Invalid image',
  'RoiBrowser.IppImages.077288-1': 'Date：',
  'RoiBrowser.IppImages.077288-2': 'Size：',
  'RoiBrowser.IppImages.077288-3': 'Class：',
  'RoiBrowser.IppImages.077288-4': 'Example',
  'RoiBrowser.index.168882-0': 'ROI Management',
  'RoiBrowser.index.168882-1': 'move to HI ROIs',
  'RoiBrowser.index.168882-2': 'Rename',
  'RoiBrowser.index.168882-3': 'Input A Name',
  'RoiBrowser.index.168882-4': 'New Temp. Class',
  'RoiBrowser.index.168882-5': 'Recycle Bin',
  'RoiBrowser.index.168882-6': 'Select All',
  'RoiBrowser.index.168882-7': 'Upload Sample ROI',
  'RoiBrowser.index.168882-8': 'Please Select',
  'RoiBrowser.index.168882-9': 'Please Input',
  'RoiBrowser.index.168882-10': 'Unselect All',
  'RoiBrowser.index.168882-11': 'Empty',
  'RoiBrowser.index.168882-12': 'Attention: The ROI # may exceeed the display maximum in My Favorite window',
  'RoiBrowser.index.168882-13': 'Switch to display hidden class (invisible by default)',
  'RoiBrowser.index.168882-14': 'Display Empty Class',
  'RoiBrowser.index.168882-15': 'New Class',
  'RoiBrowser.index.168882-16': 'Class#: {0}',
  'RoiBrowser.index.168882-17': 'ROI#{0}',
  'RoiBrowser.index.168882-18': 'HI ROIs',
  'RoiBrowser.index.168882-19': 'AI ROIs',
  'RoiBrowser.index.168882-20': 'Interface Error',
  'RoiBrowser.index.168882-21': 'No 【{0}】Class under HI ROIs',
  'RoiBrowser.index.168882-22': 'Operation not supported for Example ROIs',
  'RoiBrowser.index.168882-23': 'Permission code not configured',
  'RoiBrowser.index.168882-24': 'ROI will be moved to Recycle Bin, confirm?',
  'RoiBrowser.index.168882-25': 'Hint',
  'RoiBrowser.index.168882-26': 'Select class in My Favorite',
  'RoiBrowser.index.168882-27': 'Select class in HI ROI',
  'RoiBrowser.index.168882-28': 'Are you sure to move <span style="{0}">{1}</span> ROIs to the Recycle Bin?',
  'RoiBrowser.index.168882-29': 'Are you sure to copy <span style="{0}">{1}</span> ROIs<span style="{2}">from</span>to<span style="{3}">Xcube Gallery</span>?',
  'RoiBrowser.index.168882-30': 'Are you sure to move <span style="{0}">{1}</span> ROIs<span style="{2}">from</span>to<span style="{3}">Xcube Gallery</span>?',
  'RoiBrowser.index.168882-31': 'Are you sure to from<span style="{0}">Xcube Gallery</span> remove <span style="{1}">{2}</span> ROIs?',
  'RoiBrowser.index.168882-32': 'Are you sure to <span style="{0}">{1}</span> ROIs<span style="{2}">copy</span>to<span style="{3}">Team Gallery</span>?',
  'RoiBrowser.index.168882-33': 'Are you sure to <span style="{0}">{1}</span> ROIs<span style="{2}">move</span>into<span style="{3}">Team Gallery</span>?',
  'RoiBrowser.index.168882-34': 'Are you sure to from <span style="{0}">Team Gallery</span> Remove <span style="{1}">{2}</span> ROIs?',
  'RoiBrowser.index.168882-35': 'Are you sure to <span style="{0}">{1}</span> ROIs<span style="{2}">copy</span>to<span style="{3}">My favorite</span>?',
  'RoiBrowser.index.168882-36': 'Are you sure to remove from <span style="{0}">My favorite</span>  <span style="{1}">{2}</span> ROIs?',
  'RoiBrowser.index.168882-37': 'Are you sure to copy <span style="{0}">{1}</span> ROIs<span style="{2}"></span>to<span style="{3}">{5}</span>{4}?',
  'RoiBrowser.index.168882-38': 'Are you sure to move <span style="{0}">{1}</span> ROIs<span style="{2}">to</span><span style="{3}">{5}</span>{4}?',
  'RoiBrowser.index.168882-39': 'Are you sure to restore <span style="{0}">{1}</span> ROIs?',
  'RoiBrowser.index.168882-40': 'Are you sure copy<span style="{0}">{1}</span>to<span style="{2}">Xcube Gallery</span>?',
  'RoiBrowser.index.168882-41': 'Copy Class and ROIs inside',
  'RoiBrowser.index.168882-42': 'Are you sure copy<span style="{0}">{1}</span>to<span style="{2}">My Favorite</span>?',
  'RoiBrowser.index.168882-43': 'Are you sure copy<span style="{0}">{1}</span>to<span style="{2}">Team Gallery</span>?',
  'RoiBrowser.index.168882-44': 'Only copy ROIs in the Class',
  'RoiBrowser.index.168882-45': 'Are you sure to create<span style="{0}">{1}</span>shortcut?',
  'RoiBrowser.index.168882-46': 'Are you sure to move<span style="{0}">{1}</span>to<span style="{2}">HI ROIs</span>?',
  'RoiBrowser.index.168882-47': 'Only move in ROIs belong to the Class',
  'RoiBrowser.index.168882-48': 'Operation successful',
  'RoiBrowser.index.168882-49': 'Class name can not be empty',
  'RoiBrowser.index.168882-50': 'All ROIs',
  'layout.LayoutMenu.849809-0': 'System Configuration',
  'layout.LayoutMenu.849809-1': 'Monitoring Site',
  'layout.LayoutMenu.849809-2': 'System Overview',
  'layout.LayoutMenu.849809-3': 'GUI Management',
  'layout.LayoutMenu.849809-4': 'Team Management',
  'layout.LayoutMenu.849809-5': 'User Management',
  'layout.LayoutMenu.849809-6': 'IPP Management',
  'layout.LayoutMenu.849809-7': 'Users',
  'layout.LayoutMenu.849809-8': 'IPPs',
  'layout.LayoutMenu.849809-9': 'About',
  'layout.LayoutMenu.849809-10': 'Identify Management',
  'components.ViewRoi.525393-0': 'No image resource',
  'ipp-image-detail.config.058100-0': 'Acq. time',
  'ipp-image-detail.config.058100-1': 'Class',
  'components.EChartsPie.243795-0': 'Number',
  'components.EChartsPie.243795-1': 'Classification',
  'admin.index.960941-0': 'Exit',
  'admin.index.960941-1': 'Upload logo file',
  'admin.index.960941-2': 'Latest 24 hour data',
  'admin.index.960941-3': 'Latest 30 days data (internal Temp.)',
  'admin.index.960941-4': 'Target Classification',
  'ipp-view-detail.index.531356-0': '{0} {1}H',
  'ipp-view-detail.index.531356-1': '{0} {1}H',
  'ipp-view-detail.index.531356-2': '{0} {1}H',
  'ipp-view-detail.index.531356-3': '{0} {1}H',
  'ipp-view-detail.index.531356-4': 'Last 24 Hour',
  'ipp-view-detail.index.531356-5': 'All',
  'ipp-view-detail.index.531356-6':
    'Selected period<span style="{0}">{1}</span> ，Total ROIs<span style="{2}">{3}</span>，AI ROIs <span style="{4}">{5}</span>，HI ROIs<span style="{6}">{7}</span>，UI ROIs<span style="{8}">{9}</span>',
  'ipp-view-detail.index.531356-7': 'Total ROIs<span style="{0}">{1}</span> Classes、<span style="{2}">{3}</span>',
  'ipp-view-detail.index.531356-8': 'Total ROIs<span style="{0}">{1}</span>',
  'ipp-view-detail.index.531356-9': 'Selected period<span style="{0}">{1}</span> ，HI ROIs<span style="{2}">{3}</span>Classes、<span style="{4}">{5}</span>',
  'ipp-view-detail.index.531356-10': 'Selected period<span style="{0}">{1}</span> ，Total ROIs<span style="{2}">{3}</span>',
  'ipp-view-detail.index.531356-11': 'Selected period<span style="{0}">{1}</span> ，AI ROIs<span style="{2}">{3}</span>Classes、<span style="{4}">{5}</span>',
  'ipp-view-detail.config.628021-0': 'Xcube Gallery',
  'ipp-view-detail.config.628021-0-1': 'IPP Gallery',
  'ipp-view-detail.config.628021-1': 'Team Gallery',
  'ipp-view-detail.config.628021-2': 'Favorite Gallery',
  'ipp-view-detail.config.628021-3': 'Raw ROIs',
  'ipp-view-detail.config.628021-4': 'AI ROIs',
  'ipp-view-detail.config.628021-5': 'HI ROIs',
  'ipp-view-detail.config.628021-6': 'time',
  'ipp-view-detail.config.628021-7': 'size(kb)',
  'ipp-view-detail.config.628021-8': 'number',
  'ipp-view-detail.config.628021-9': 'highlighted',
  'ipp-view-detail.config.628021-10': 'name',
  'ipp-view-detail.config.628021-11': 'Abundance',
  'ipp-view-detail.config.628021-12': 'Volume',
  'ipp-view-detail.config.628021-13': 'Size',
  'ipp-view-detail.config.628021-14': 'Latest 24 Hour',
  'ipp-view-detail.config.628021-15': '3 Days',
  'ipp-view-detail.config.628021-16': '7 Days',
  'ipp-view-detail.config.628021-17': '15 Days',
  'ipp-view-detail.config.628021-18': '1 Month',
  'ipp-view-detail.config.628021-19': '3 Months',
  'ipp-view-detail.config.628021-20': '6 Months',
  'ipp-view-detail.config.628021-21': '1 Year',
  'ipp-view-detail.config.628021-22': 'All',
  'ipp-view-detail.config.628021-23': 'identify',
  'ipp-view-detail.config.628021-24': 'pixel#(px)',
  'ipp-view.index.588907-0': 'Last 30 Days',
  'RoiBrowser.utils.074098-0': 'Select All',
  'RoiBrowser.utils.074098-1': 'Recycle Bin',
  'RoiBrowser.utils.074098-2': 'Copy to Xcube Gallery',
  'RoiBrowser.utils.074098-3': 'Move to Xcube Gallery',
  'RoiBrowser.utils.074098-4': 'Remove ROI',
  'RoiBrowser.utils.074098-5': 'Copy to Team Gallery',
  'RoiBrowser.utils.074098-6': 'Move to Team Gallery',
  'RoiBrowser.utils.074098-7': 'Out Gallery',
  'RoiBrowser.utils.074098-8': 'Copy to Favorite Gallery',
  'RoiBrowser.utils.074098-9': 'Move to Favorite Gallery',
  'RoiBrowser.utils.074098-10': 'Out Favorite Gallery',
  'RoiBrowser.utils.074098-11': 'Copy to HI ROI',
  'RoiBrowser.utils.074098-12': 'Redo HI',
  'RoiBrowser.utils.074098-13': 'Move to HI ROI',
  'RoiBrowser.utils.074098-14': 'Copy to',
  'RoiBrowser.utils.074098-15': 'Move into',
  'RoiBrowser.utils.074098-16': 'Restore',
  'RoiBrowser.utils.074098-17': 'Remove',
  'RoiBrowser.utils.074098-18': 'New Class',
  'RoiBrowser.utils.074098-19': 'User visible',
  'RoiBrowser.utils.074098-20': 'User invisible',
  'RoiBrowser.utils.074098-21': 'Class and ROI',
  'RoiBrowser.utils.074098-22': 'Class',
  'RoiBrowser.utils.074098-23': 'ROI',
  'RoiBrowser.utils.074098-24': 'Rename',
  'RoiBrowser.utils.074098-25': 'Move to Temp. Class',
  'RoiBrowser.utils.074098-26': 'Copy to Temp. Class',
  'RoiBrowser.utils.074098-27': 'Delete Class',
  'RoiBrowser.utils.074098-28': 'Add Attension',
  'RoiBrowser.utils.074098-29': 'Cancel Attension',
  'RoiBrowser.utils.074098-30': 'Rename',
  'RoiBrowser.utils.074098-31': 'Remove ROI',
  'RoiBrowser.utils.074098-32': 'Approve',
  'RoiBrowser.utils.074098-33': 'Reject',
  'RoiBrowser.utils.074098-34': 'Move to IPP Gallery',
  'RoiBrowser.utils.074098-35': 'Copy to IPP Gallery',
  'components.DialogReidentificationRoi.530547-0': 'ReID',
  'components.DialogReidentificationRoi.530547-1': 'Time range',
  'components.DialogReidentificationRoi.530547-2': 'AI Class',
  'components.DialogReidentificationRoi.530547-3': 'Please select',
  'components.DialogReidentificationRoi.530547-4': 'Submit',
  'components.DialogReidentificationRoi.530547-5': 'Cancel',
  'components.DialogReidentificationRoi.530547-6': 'Please select date',
  'components.DialogReidentificationRoi.530547-7': 'Retrieve dev_id fail',
  'components.DialogReidentificationRoi.530547-8': 'Operation Successful.',
  'views.about.514986-0':
    "IPP Console System (Software Copyright No. 13042359) is an intelligent IoT (AIoT)-based instrument control and monitoring information management platform developed by Shenzhen Xcube Technology Co., Ltd., specifically for the in situ Imaging Plankton Probe (IPP). By deploying and using the IPP Console system, users can configure and monitor the operational status of their team's IPP devices, and continuously acquire image data collected in real-time from multiple deployment locations via network. Through image processing, AI recognition, and statistical analysis algorithms running on both the edge and the cloud, users can obtain real-time, continuous, in situ observations of plankton and underwater particulates across broader spatial and temporal scales. IPP Console also provides a hierarchical management feature, enabling teams to efficiently manage users and instruments according to their organizational needs.",
  'floatModal.mini': 'Mini Mode',
  'floatModal.fullscreen': 'Fullscreen',
  'floatModal.exitFullscreen': 'Exit Fullscreen',
  'floatModal.alwaysTop': 'Always on Top',
  'floatModal.cancelTop': 'Cancel Top',
  'floatModal.setTop': 'Pin to Top',
  'floatModal.restoreWindow': 'Restore Window',
  'floatModal.close': 'Close',
  'floatModal.restore': 'Click to Restore'
};
